// extracted by mini-css-extract-plugin
module.exports = {"page":"ManagerList_page__bkmg8","mainTable":"ManagerList_mainTable__2Slsg"};